import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { AppContainer } from 'react-hot-loader';

const render = () => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <App />
    </AppContainer>,
    document.getElementById('root')
  );
};

render();

if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}


// WEBPACK FOOTER //
// ./src/index.js